import { Button, ButtonProps, Input, Modal, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { useCreateCoverageConfirmationTransitionMutation } from "../../redux/api/coverageConfirmationApiSlice";
import { CoverageConfirmation } from "../../types/negotiations";
import { SubmissionStates } from "./SelectSurveyPageCard";

export default function DeclineSubmissionButton({ coverageConfirmation, buttonProps }: {
  coverageConfirmation: CoverageConfirmation,
  buttonProps?: ButtonProps
}) {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [currentNote, setCurrentNote] = useState<string>("");
  const [declineValue, setDeclineValue] = useState<string | null>(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);

  const [createTransition] = useCreateCoverageConfirmationTransitionMutation();

  useEffect(() => {
    let disabled: boolean = false;
    if (coverageConfirmation.submission_state === SubmissionStates.QUOTATION_SENT || coverageConfirmation.submission_state === SubmissionStates.CONFIRMATION_SENT)
      disabled = true;
    setIsButtonDisabled(disabled);
  }, [coverageConfirmation.submission_state]);

  const onConfirmModal = () => {
    if (declineValue) {
      createTransition({
        coverageConfirmationUuid: coverageConfirmation.uuid,
        state_cc_to: "0100",
        notes: currentNote,
        reason: declineValue
      });
      setCurrentNote("");
      setDeclineValue(null);
      setIsModalOpen(false);
    }
  };

  const declineOptions = [
    {
      "value": "DEC-1",
      "label": "Target premio basso"
    },
    {
      "value": "DEC-2",
      "label": "Condizioni tecniche"
    },
    {
      "value": "DEC-3",
      "label": "Attività non in appetito"
    },
    {
      "value": "DEC-4",
      "label": "Sinistrosità troppo alta"
    },
    {
      "value": "DEC-5",
      "label": "Assenza di informazioni tecniche"
    },
    {
      "value": "DEC-6",
      "label": "Richiesta copertura in paesi Extra-UE"
    }
  ];

  return <>
    <Modal open={isModalOpen}
           title={"Declina Submission"}
           okButtonProps={{ danger: true, disabled: !declineValue }}
           okText={"Declina"}
           onOk={() => onConfirmModal()}
           onCancel={() => {
             setCurrentNote("");
             setDeclineValue(null);
             setIsModalOpen(false);
           }}
    >
      <div style={{ marginBottom: "1rem" }}>Sei sicuro di voler declinare questa submission?</div>
      <Space direction={"vertical"} style={{ width: "100%" }}>
        <div>
          Motivazione
        </div>
        <Select
          options={declineOptions}
          value={declineValue}
          onChange={v => setDeclineValue(v)}
          style={{ width: "100%" }} />
        <div>
          Commento:
        </div>
        <Input.TextArea value={currentNote} onChange={e => setCurrentNote(e.target.value)} />
      </Space>
    </Modal>
    <Button
      type={"primary"}
      danger
      ghost
      {...buttonProps}
      disabled={isButtonDisabled || buttonProps?.disabled}
      style={{ width: "100%", ...buttonProps?.style }}
      onClick={(e) => {
        buttonProps?.onClick?.(e);
        setIsModalOpen(true);
      }}>
      Declina
    </Button>
  </>;
}